<div class="image-holder" (click)="onClick($event)" [class.disabled]="disabled">
    <div class="dropzone">
        <svg-icon *ngIf="!imageUrl" src="/assets/shared/svg/img.svg"></svg-icon>
        <img *ngIf="imageUrl" [src]="imageUrl" alt="Cover image" class="tile-cover">
    </div>
    <p>Choose an image</p>
</div>
